const answer = `When we talk about "suns," we are talking about **stars**. Our Sun is just one of trillions of stars in the universe, and compared to some of them, it is incredibly tiny.

Depending on how astronomers calculate the distance and size of these distant giants, the title for the largest known star usually comes down to two major contenders:

## 1. Stephenson 2-18 (The Current Heavyweight)
Many astronomers consider **Stephenson 2-18** (also known as Stephenson 2 DFK 1) to be the largest known star. It is a red hypergiant located about 19,000 light-years away from Earth.

* **The Scale:** It has an estimated radius of around **2,150 times** that of our Sun.
* **Mind-Boggling Size:** If you replaced our Sun with Stephenson 2-18, its outer edge would swallow Mercury, Venus, Earth, Mars, Jupiter, and would reach all the way out to the orbit of **Saturn**. You could fit nearly 10 billion Suns inside it.

## 2. UY Scuti (The Famous Challenger)
For a long time, **UY Scuti** was widely cited as the reigning champion, and it is still one of the most famous cosmic monsters. It is a variable red hypergiant located roughly 9,500 light-years away in the constellation Scutum.

* **The Scale:** Older estimates placed its radius at around **1,700 times** that of the Sun.
* **The Catch:** Measuring stars thousands of light-years away is incredibly tricky because they are surrounded by thick clouds of dust and gas. More recent measurements suggest UY Scuti might actually be smaller than originally thought (closer to 755 to 900 solar radii), which dropped it down the leaderboard.

---

### Mass vs. Size: A Quick Cosmic Secret
It is important to know that being the *largest* in size (volume) doesn't mean being the *heaviest* (mass).

These giant stars are like giant cosmic hot air balloons—they are massive and puffy because they are reaching the end of their lives and blowing outward, but they are actually quite hollow and less dense. A star like **R136a1** is much physically smaller than Stephenson 2-18, but it is the *most massive* star known, weighing roughly 200 to 300 times the mass of our Sun!

Would you like to explore how these hypergiant stars eventually end their lives?`;

const response = {
  query: "What is the largest sun in the universe?",
  url: "https://gemini.google.com/",
  model: "3.5 Flash",
  answer,
  sources: [
    {
      title: "The Largest Stars in the Universe #Sun #Stars #Space #Planets #Shorts - \nYouTube",
      url: "https://www.youtube.com/shorts/85OBZjCs-LY",
      domain: "youtube.com",
      snippet: "Explore the true scale of the cosmos as we journey from our home star to \nsome of the largest known objects in the universe. While our sun dominates \nour solar ..."
    },
    {
      title: "The largest known star in the universe is UY Scuti, a hypergiant with a \nradius around 1,700 times larger than the sun. If it were placed in our \nsolar system, it would extend beyond the orbit of Jupiter. : r/spaceporn - \nReddit",
      url: "https://www.reddit.com/r/spaceporn/comments/15b0xrn/the_largest_known_star_in_the_universe_is_uy/#:~:text=Comments%20Section,3y%20ago",
      domain: "reddit.com",
      snippet: "Comments Section. Romulo_Gabriel. • 3y ago. The Largest star is actually \nStephenson 2-18 With a radius 2,100 Times Larger Than The Sun. If it was \nplaced in our ..."
    },
    {
      title: "What is the biggest star in the universe? - Space",
      url: "https://www.space.com/41290-biggest-star.html#:~:text=Where%20is%20UY%20Scuti%3F,stars%20that%20shine%20very%20brightly.",
      domain: "space.com",
      snippet: "Where is UY Scuti? The star lies near the center of the Milky Way, roughly \n9,500 light-years away from Earth. Located within the constellation Scutum, \nUY Scuti ..."
    }
  ],
  related_queries: []
};

export const async_google_gemini = {
  input: "What is the largest sun in the universe?",
  result: JSON.stringify(response, null, 2)
};
